import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import * as CSS from 'csstype';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DataTestidDirective } from '../../directives/data-testid/data-testid.directive';

@Component({
  imports: [CommonModule, DataTestidDirective, FormsModule],
  selector: 'rd-shared-keyword-filter',
  templateUrl: './keyword-filter.component.html',
  styleUrls: ['./keyword-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeywordFilterComponent implements OnInit, OnDestroy {
  @HostBinding('class.rd-shared-keyword-filter') componentClass = true;
  @HostBinding('class.is-focused') isFocusedClass = false;
  @HostBinding('class.is-filled') get isFilled(): boolean {
    return this.keyword !== '';
  }
  @Input() keyword: string;
  @Input() keywordPlaceholder: string;
  @Output() keywordChange = new EventEmitter();

  private keywordChangedObservable$: Subject<string> = new Subject<string>();
  private DEBOUNCE_TIME = 500;

  constructor(protected urlUtilsService: UrlUtilsService) {}

  ngOnInit(): void {
    this.keywordChangedObservable$
      .pipe(debounceTime(this.DEBOUNCE_TIME))
      .subscribe((value) => {
        this.keywordChange.emit(value);
      });
  }

  ngOnDestroy(): void {
    this.keywordChangedObservable$.unsubscribe();
  }

  keywordChanged(): void {
    this.keywordChangedObservable$.next(this.keyword);
  }

  keywordFilterBackgroundImageStyle(): CSS.Properties {
    return {
      backgroundImage: `url(${this.urlUtilsService.imageUrl(
        '/images/rd-search-icon.png',
      )})`,
    };
  }

  onFocus(): void {
    this.isFocusedClass = true;
  }

  onBlur(): void {
    this.isFocusedClass = false;
  }
}
